import { render } from "./Paginate.vue?vue&type=template&id=1cb4f091&scoped=true"
import script from "./Paginate.vue?vue&type=script&lang=js"
export * from "./Paginate.vue?vue&type=script&lang=js"

import "./Paginate.vue?vue&type=style&index=0&id=1cb4f091&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-1cb4f091"

export default script